import { Component } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { AlertCircle } from "lucide-react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary:", error, info?.componentStack);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
    window.location.assign("/analyze");
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-orange-50 flex flex-col items-center justify-center px-4">
          <div className="max-w-md w-full text-center space-y-4">
            <AlertCircle className="w-14 h-14 text-orange-500 mx-auto" />
            <h1 className="text-xl font-semibold text-gray-900">Something went wrong</h1>
            <p className="text-sm text-gray-600">
              The app hit an unexpected error. You can go back to analyze or reload this page.
            </p>
            {process.env.NODE_ENV === "development" && this.state.error?.message && (
              <pre className="text-left text-xs bg-red-50 border border-red-100 rounded-lg p-3 overflow-auto max-h-40 text-red-800">
                {this.state.error.message}
              </pre>
            )}
            <div className="flex flex-col sm:flex-row gap-2 justify-center pt-2">
              <Button onClick={this.handleRetry} className="bg-orange-500 hover:bg-orange-600">
                Go to Analyze
              </Button>
              <Button variant="outline" onClick={() => window.location.reload()}>
                Reload page
              </Button>
            </div>
            <Link to="/analyze" className="text-sm text-orange-600 hover:underline inline-block">
              Home
            </Link>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
